<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [information]="'PIXELS'">
  <div app-theme-option-content>
    <app-number [value]="themeOptions.options().gauge.pointerOptions.bottomlength" (sendValue)="receiveValue($event)" [color]="color" [min]="-34" [max]="24" [step]="2"></app-number>
  </div>
</app-theme-option>